<script>
import { Bar, mixins } from "vue-chartjs";
import chartMixins from "./chartMixin";

const { reactiveProp } = mixins;
export default {
	extends: Bar,
	mixins: [chartMixins, reactiveProp],
	props: {},
	data() {
		return {
			dataset: []
		};
	},
	computed: {
		options() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false,
					labels: {
						fontSize: 13
					}
				},
				scales: {
					yAxes: [
						{
							ticks: {
								display: false,
								beginAtZero: true, // minimum value will be 0.
								suggestedMax: Math.max(...this.dataset) + 1,
								stepSize: Math.max(...this.dataset) <= 5 ? 1 : 2
							}
						}
					],
					xAxes: [
						{
							gridLines: {
								drawOnChartArea: false
							},
							ticks: {
								fontSize: 13,
								autoSkip: false
							}
						}
					]
				},
				tooltips: {
					enabled: this.showTooltip,
					callbacks: {
						title: (tooltipItem, data) => {
							return data["labels"][tooltipItem[0]["index"]];
						},
						label: (tooltipItem, graphData) => {
							const { data } = graphData.datasets[0];
							return `${data[tooltipItem.index]}${this.prependTooltip}`;
						}
					}
				}
			};
		}
	},
	mounted() {
		this.dataset = this.chartData.datasets[0].data || [];
		this.renderChart(this.chartData, this.options);
	}
};
</script>
